import { useState, useEffect } from "react";
import { api } from "@/lib/auth";
import { PageHeader, Card, Btn, Icon } from "@/components/kit";
import { toast } from "sonner";

export default function Appointments() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/appointments").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-gray-400">Loading bookings…</div>;

  const url = `${window.location.origin}/book/${data.slug}`;
  return (
    <div className="fade-up">
      <PageHeader demo={false} title="Bookings" subtitle="Your Calendly-style booking page — clients pick a slot, it lands here." icon="CalendarClock" color="#F97316" />

      <Card className="mb-5 flex flex-wrap items-center gap-3">
        <Icon name="Link2" size={18} className="text-orange-500" />
        <a href={url} target="_blank" rel="noreferrer" data-testid="booking-public-link" className="text-blue-600 font-medium truncate">{url}</a>
        <div className="ml-auto flex gap-2">
          <Btn variant="outline" onClick={() => { navigator.clipboard.writeText(url); toast.success("Booking link copied"); }}><Icon name="Copy" size={14} /> Copy link</Btn>
          <Btn variant="soft" onClick={() => window.open(url, "_blank")}><Icon name="ExternalLink" size={14} /> Preview</Btn>
        </div>
      </Card>

      <Card>
        <h3 className="font-head font-semibold text-lg mb-4">Upcoming & recent bookings</h3>
        {data.appointments.length === 0 ? (
          <div className="text-center py-10 text-gray-400"><Icon name="CalendarX" size={30} className="mx-auto mb-2" />No bookings yet. Share your link to start receiving meetings.</div>
        ) : (
          <div className="space-y-2">
            {data.appointments.map((a) => (
              <div key={a.id} className="flex flex-wrap items-center gap-3 rounded-xl border border-gray-100 p-4" data-testid="appointment-row">
                <div className="w-10 h-10 rounded-xl bg-orange-50 grid place-items-center"><Icon name="Calendar" size={18} className="text-orange-500" /></div>
                <div className="min-w-0"><div className="font-medium">{a.client_name}</div><div className="text-xs text-gray-400">{a.client_email}</div></div>
                <div className="text-sm text-gray-600">{a.meeting_type}</div>
                <span className="text-xs bg-blue-50 text-blue-600 rounded-full px-2.5 py-1 font-semibold">{a.duration}</span>
                <div className="ml-auto text-sm font-medium">{a.date} · {a.time}</div>
                <span className="text-[11px] bg-emerald-50 text-emerald-600 rounded-full px-2.5 py-0.5 font-semibold">{a.status}</span>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
